import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { HttpClient } from '@angular/common/http';

import { PageAction } from '../../../components/page-actions/page-actions.component';
import { CustomerService } from '@services/customers/customer.service';
import { ImportService } from '@services/imports/import.service';
import { ImportTypeService } from '@services/import-types/import-type.service';
import { ImportLogsService } from '@services/import-logs/import-logs.service';
import { PackageService } from '@services/packages/package.service';
import { JsonService } from '@services/jsons/json.service';
import * as _ from 'lodash';
import { GeneratorDialogComponent } from '../../../dialogs/generator-dialog/generator-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CodeSnippetService } from '@services/code-snippets/code-snippet.service';
import { CustomerEraserComponent } from './customer-eraser/customer-eraser.component';

@Component({
    selector: 'app-customer-detail',
    templateUrl: 'customer-detail.component.html',
    styleUrls: ['customer-detail.component.scss'],
    providers: [CustomerService, ImportService, ImportTypeService, ImportLogsService, PackageService, JsonService, CodeSnippetService],
    standalone: false
})
export class CustomerDetailComponent implements OnInit {

  public customer: Models.Customer;
  public customerId;
  public customerImports = [];
  public title: string;
  public pageActions: PageAction[];
  public isLoading: boolean;
  public columnsPackage = [
    { prop: 'title' },
    { prop: 'tweebie.isDestination', name: 'Destination' }
  ];
  public paramsPackage;
  public params: any;
  public cfList = [];
  private existingJsonsByLang = {};
  private baseJsonsByName = {};

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private importService: ImportService,
    private importTypeService: ImportTypeService,
    public importLogsService: ImportLogsService,
    public packageService: PackageService,
    private jsonService: JsonService,
    private http: HttpClient,
    private dialog: MatDialog,
    private snippetService: CodeSnippetService
  ) {
    this.customerId = this.route.snapshot.params['id'];
    this.paramsPackage = { customerId: this.customerId };
  }

  ngOnInit() {
    this.createPageActions();
    this.isLoading = true;
    this.customerService.get(this.customerId).then(response => {
      this.customer = response;
      this.title = 'Customer: ' + response.company;
      this.loadData(this.customerId);
      if (this.customer.screenUuids && this.customer.screenUuids.length) {
        this.jsonService.find(0, 100, { screenUUID: { $in: this.customer.screenUuids }, language: 'cf' }).then(cfResult => {
          if (cfResult && cfResult.data && cfResult.data.length > 0) {
            this.cfList = cfResult.data;
          }
        });
      }
      this.isLoading = false;
    });
  }

  public generateArray(data) {
    return new Promise((resolve, reject) => {
      const array = [];
      const importTypeIds = [];
      for (const element of data) {
        if (importTypeIds.indexOf(element.typeId) === -1) {
          importTypeIds.push(element.typeId)
        }
      }
      this.importTypeService.find(0, 100, { _id: { $in: importTypeIds } }).then(importTypes => {
        data.map(entry => {
          let resultImportType: any = {};
          for (const importType of importTypes.data) {
            if (importType._id === entry.typeId) {
              resultImportType = importType;
            }
          }
          const properties = (entry.importProperties && Object.keys(entry.importProperties).length !== 0 ? entry.importProperties : []);
          const assignable = (entry.assignableMenuItems && Object.keys(entry.assignableMenuItems).length !== 0 ? entry.assignableMenuItems : []);
          const fetchLog = resultImportType.title === 'GuidleEvents' || resultImportType.title === 'SBB Daily Schedules' || resultImportType.title === 'Ticker';
          array.push({
            id: entry._id,
            name: entry.title,
            url: '/imports/' + entry._id,
            importType: resultImportType.title,
            properties: properties,
            assignable: assignable,
            fetchLog: fetchLog,
          });
          if (data.length === array.length) {
            resolve(array);
          }
        });
      });
    });
  }

  public fetchLog(id) {
    this.importLogsService.find(0, 1, { importId: id, $sort: { created: -1 } }).then(response => {
      this.router.navigate(['import-logs', response.data[0]._id]);
    });
  }

  onDetailPackage(event) {
    this.router.navigate(['packages', event.row._id])
  }

  generateCustomJsons() {
    const dialogRef = this.dialog.open(GeneratorDialogComponent, <MatDialogConfig>{
      width: '330px',
      height: '200px'
    });
    dialogRef.afterClosed().toPromise().then(res => {
      if (res) {
        for (const cf of this.cfList) {
          const cfJson = JSON.parse(cf.data);
          cfJson.season = res;
          const codeSnippetNames = [];
          for (const lang of cfJson.languages) {
            codeSnippetNames.push(cfJson[lang].baseJSONName);
          }
          this.snippetService.find(0, cfJson.languages.length, {
            name: { $in: codeSnippetNames }
          }).then(jsons => {
            for (const json of jsons.data) {
              this.baseJsonsByName[json.name] = JSON.parse(json.code);
            }
            const generatedJsons = this.generate(cfJson);
            for (const k in generatedJsons) {
              if (generatedJsons.hasOwnProperty(k)) {
                (key => {
                  this.jsonService.find(0, 1, {
                    language: key,
                    screenUUID: cf.screenUUID
                  }).then(existingJson => {
                    if (existingJson && existingJson.total && existingJson.total === 1) {
                      const jsonData = _.clone(existingJson.data[0]);
                      jsonData.data = JSON.stringify(generatedJsons[key]);
                      this.jsonService.update(existingJson.data[0]._id, jsonData);
                    } else {
                      const data = new Models.FakeJSON;
                      data.populateFromJSON({
                        data: JSON.stringify(generatedJsons[key]),
                        language: key,
                        screenUUID: cf.screenUUID
                      });
                      this.jsonService.create(data);
                    }
                  });
                })(k);
              }
            }
          });
        }
      }
    });
  }

  generate(config) {
    if (config.season) {
      for (const lang of config.languages) {
        for (const key in config[lang].config) {
          if (config[lang].config.hasOwnProperty(key)) {
            config[lang].config[key] = _.remove(config[lang].config[key], (element: any) => {
              return element.season ? element.season === config.season : true;
            });
          }
        }
      }
      for (const key in config.general) {
        if (config.general.hasOwnProperty(key)) {
          config.general[key] = _.remove(config.general[key], (element: any) => {
            return element.season ? element.season === config.season : true;
          });
        }
      }
    }
    const jsons = {};
    for (const lang of config.languages) {
      if (config[lang] && config[lang].config && this.baseJsonsByName[config[lang].baseJSONName]) {
        jsons[lang] = this.applyConfig(config[lang].config, this.baseJsonsByName[config[lang].baseJSONName]);
      }
    }

    for (const key in jsons) {
      if (jsons.hasOwnProperty(key)) {
        jsons[key] = this.applyConfig(config.general, jsons[key]);
      }
    }

    for (const lang of config.languages) {
      if (config[lang] && config[lang].config) {
        if (config[lang].config.textOverwrites) {
          for (const item of config[lang].config.textOverwrites) {
            jsons[lang] = JSON.parse(_.replace(JSON.stringify(jsons[lang]), new RegExp(item.old.replace(/\$/g, '\\\$'), 'g'), item.new));
          }
        }
      }
    }

    return jsons;
  }

  applyConfig(config, json) {
    if (config.extends) {
      json = this.extend(config.extends, json);
    }
    if (config.order) {
      json = this.reorder(config.order, json);
    }
    if (config.overwrites) {
      json = this.overwrite(config.overwrites, json);
    }
    if (config.textOverwrites) {
      for (const item of config.textOverwrites) {
        json = JSON.parse(_.replace(JSON.stringify(json), new RegExp(item.old.replace(/\$/g, '\\\$'), 'g'), item.new));
      }
    }
    if (config.removes) {
      json = this.remove(config.removes, json);
    }
    if (config.additionalFields) {
      json = this.addFields(config.additionalFields, json);
    }
    return json;
  }

  extend(config, json) {
    for (const item of config) {
      if (item.location === 'entries') {
        json.entries[item.id] = item.element;
      } else if (item.location === 'items') {
        if (item.key) {
          if (item.position) {
            json.menu.items[item.key]['children'].splice(item.position, 0, item.element);
          } else { // push it at the end
            json.menu.items[item.key]['children'].push(item.element);
          }
        } else {
          json.menu.items[item.id] = item.element;
        }
      } else if (item.location === 'files') {
        json.files[item.id] = item.element;
      }
    }
    return json;
  }

  reorder(config, json) {
    for (const item of config) {
      if (item.id) {
        if (json.entries && json.entries[item.id] && json.entries[item.id]) {
          if (item.config) {
            json.entries[item.id].related = this.moveTo(item.config.key, item.config.value, json.entries[item.id].related, item.config.newPosition);
          }
        } else if (json.menu && json.menu.items && json.menu.items[item.id] && json.menu.items[item.id].children) {
          if (item.config) {
            json.menu.items[item.id].children = this.moveTo(item.config.key, item.config.value, json.menu.items[item.id].children, item.config.newPosition);
          }
        }
      }
    }
    return json;
  }

  overwrite(config, json) {
    for (const item of config) {
      if (item.id && item.element) {
        if (json.entries[item.id]) {
          json.entries[item.id] = item.element;
        } else if (json.files[item.id]) {
          json.files[item.id] = item.element;
        } else if (json.menu && json.menu.items[item.id]) {
          json.menu.items[item.id] = item.element;
        }
      }
    }
    return json;
  }

  remove(config, json) {
    for (const item of config) {
      delete json.entries[item.id];
      delete json.files[item.id];
      delete json.menu.items[item.id];
    }
    return json;
  }

  moveTo(key, value, array, position: any = 0) {
    if (_.isString(position)) {
      position = position === 'last' ? array.length - 1 : 0;
    }
    for (let i = 0; i < array.length; i++) {
      if (array[i][key] && array[i][key] === value) {
        const item = _.clone(array[i]);
        array.splice(i, 1);
        array.splice(position, 0, item);
      }
    }
    return array;
  }

  private loadData(id) {
    if (!id || !id.length) {
      return;
    }
    this.importService.find(0, 100, { customerId: id }).then(resultImporter => {
      this.generateArray(resultImporter.data).then(result => {
        this.customerImports = _.chain(<[]>result).sortBy('name').sortBy('importType').value();
      });
    });

  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Overview Customers',
        callback: () => {
          this.router.navigate(['customers']);
        }
      }),
      new PageAction({
        icon: 'edit',
        title: 'Edit Customer',
        callback: () => {
          this.router.navigate(['customers', this.customer._id, 'edit']);
        }
      }),
      new PageAction({
        icon: 'create_new_folder',
        title: 'Create package',
        callback: () => {
          this.router.navigate(['packages/create', this.customer._id]);
        }
      }),
      new PageAction({
        icon: 'info',
        title: 'Statistik',
        callback: () => {
          this.router.navigate(['analytics', 'ibex3', this.customer._id, this.customer.company]);
        }
      }),

      new PageAction({
        icon: 'delete',
        title: 'Erase Customer',
        callback: () => {
          const config: MatDialogConfig = <any>{ data: { customer: this.customer } };
          this.dialog.open(CustomerEraserComponent, config);
        }
      })
    ];
  }

  private addFields(config, json) {
    for (const item of config) {
      if (item.location === 'entries') {
        json.entries[item.id] = this.addFieldNested(json.entries[item.id], item.field, item.value);
      }
      if (item.location === 'items') {
        json.menu.items[item.id] = this.addFieldNested(json.menu.items[item.id], item.field, item.value);
      }
      if (item.location === 'files') {
        json.files[item.id] = this.addFieldNested(json.files[item.id], item.field, item.value);
      }
    }
    return json;
  }

  private addFieldNested(obj, path, value) {
    const a = path.split('.');
    let o = obj;
    while (a.length - 1) {
      const n = a.shift();
      if (!(n in o)) {
        o[n] = {};
      }
      o = o[n];
    }
    o[a[0]] = value;
    return obj;
  }

}
